document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__accordion .accordion__title').forEach(function (titleEl) {
    if (titleEl.textContent.trim().includes('Beschreibung')) {
      const accordion = titleEl.closest('.product__accordion');
      const content = accordion.querySelector('.accordion__content');
      if (!content) return;

      let totalText = '';
      content.querySelectorAll('p').forEach(p => totalText += p.textContent);
      if (totalText.length <= 100) return;

      content.classList.add('read-more--collapsed');

      const btn = document.createElement('button');
      btn.className = 'read-more__btn';
      btn.textContent = 'Weiterlesen';
      content.after(btn);

      btn.addEventListener('click', function () {
        const collapsed = content.classList.toggle('read-more--collapsed');
        btn.textContent = collapsed ? 'Weiterlesen' : 'Weniger anzeigen';
      });
    }
  });
});





